




















































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import '@/compiled-icons/format-align-center';
import '@/compiled-icons/format-align-left';
import '@/compiled-icons/format-align-right';
import '@/compiled-icons/toy-brick-plus-outline';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';

import '@/compiled-icons/add';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import AmetrasHexColorPickerTemplate from '@/fields/hex-color-picker/AmetrasHexColorPickerTemplate.vue';
import DynamicDocumentFontConfigurationTemplate from '@/views/dynamicdocuments/fields/dynamic-document-font-configuration-template.vue';

@Component({
  name: 'dynamic-document-text-field-template',
  components: {
    DynamicDocumentFontConfigurationTemplate,
    AmetrasHexColorPickerTemplate,
    AmetrasTextAreaFieldTemplate,
    AmetrasNumberFieldTemplate,
    AmetrasCheckBoxTemplate,
    AmetrasTextFieldTemplate,
    AmetrasSelectFieldTemplate
  }
})
export default class DynamicDocumentTextFieldTemplate extends Vue {

  @Prop({required: true}) fieldConfig: DisguiseDto.DynamicDocumentFieldTypeTextDtoV2 | undefined;
  @Prop({required: false}) replacementToken: DisguiseDto.DynamicDocumentReplacementTokenDto[] | undefined;

  brickMenuOpened = false;

  $refs!: {
    input: AmetrasTextAreaFieldTemplate | AmetrasTextFieldTemplate
  };

  insertBrick(brick: DisguiseDto.DynamicDocumentReplacementTokenDto) {
    const textArea = this.$refs.input;
    if (textArea && brick.replacementToken && this.fieldConfig) {
      const htmlTextAreaField = textArea.$el.querySelector('textarea');
      const htmlInputField = textArea.$el.querySelector('input');
      if (htmlTextAreaField) {
        const oldText = this.fieldConfig.value || '';
        this.fieldConfig.value = oldText.substring(0, htmlTextAreaField.selectionStart)
          + brick.replacementToken
          + oldText.substring(htmlTextAreaField.selectionEnd, oldText.length);
      } else if (htmlInputField) {
        const oldText = this.fieldConfig.value || '';
        this.fieldConfig.value = oldText.substring(0, htmlInputField.selectionStart || 0)
          + brick.replacementToken
          + oldText.substring(htmlInputField.selectionEnd || 0, oldText.length);
      }
    }
  }

}
